import React from 'react';
import { connect } from 'react-redux';

var map = null;
var markers = [];
var tempOrders = [];

var green = "green";
var red = "default";
var hardwood = "orange";
var black = "gray";
var cedar = 'tan'
var multiple = "violet";
var orderId = 0;
var editOrder = null;
class DeliveryMap extends React.PureComponent {

    componentDidMount() {
        tempOrders = []
        map = new window.google.maps.Map(document.getElementById('map'), {
            center: { lat: 33.19501, lng: -96.67336 },
            zoom: 13,
            mapTypeId: 'roadmap',
        });
    }

    componentDidUpdate() {
        if (this.props.mapOrders && this.props.mapOrders.length > 0) {
            if (markers.length == 0) {
                let bounds = new window.google.maps.LatLngBounds();
                for (let l in this.props.mapOrders) {
                    if (this.props.mapOrders[l].deliveryType == 'delivery' && (this.props.mapOrders[l].deliveryId == 0 || this.props.mapOrders[l].deliveryId == this.props.deliveryId)) {
                        this.addMarker(map, this.props.mapOrders[l])
                    }
                    bounds.extend({ lat: Number(this.props.mapOrders[l].geoLat), lng: Number(this.props.mapOrders[l].geoLon) })
                }
                //if (this.state.firstTime) {
                map.setCenter({ lat: Number(this.props.mapOrders[0].geoLat), lng: Number(this.props.mapOrders[0].geoLon) });
                //map.fitBounds(bounds);
                map.panToBounds(bounds);
                //}
            }
            else {

                //if (orderId == 0 || !editOrder) { 

                for (let l in this.props.mapOrders) {
                    let order = this.props.mapOrders[l]
                    for (let k in markers) {
                        if (markers[k].title.startsWith(order.orderId + ":")) {
                            let logo = markers[k].icon.url;
                            if ((logo.indexOf(green) > 0 && order.deliveryId == 0) || (logo.indexOf(green) < 0 && order.deliveryId != 0)) {
                                editOrder = order
                                orderId = order.orderId
                                this.updateExisting()
                            }
                        }
                    }
                }

            }
        }
    }

    updateExisting() {
        orderId = 0;
        if (editOrder.deliveryType == 'delivery' && (editOrder.deliveryId == 0 || editOrder.deliveryId == this.props.deliveryId)) {
            let color = green
            let types = 0;
            if (editOrder.deliveryId == 0) {
                for (let k in markers) {
                    if (markers[k].title.startsWith(editOrder.orderId + ":")) {
                        let logo = markers[k].icon.url;

                        if (logo.indexOf(green) < 0) {
                            break;
                        }

                        if (editOrder.hardwoodBags > 0) {
                            types = types + 1;
                            color = hardwood;
                        }
                        if (editOrder.cedarBags > 0) {
                            types = types + 1;
                            color = cedar;
                        }
                        if (editOrder.blackBags > 0) {
                            types = types + 1;
                            color = black;
                        }
                        if (editOrder.redBags > 0) {
                            types = types + 1;
                            color = red;
                        }

                        if (types > 1) {
                            color = multiple;
                        }
                        logo = logo.replace(green, color);
                        markers[k].setIcon({ url: logo });
                        break;
                    }
                }
            }
            else {
                for (let k in markers) {
                    if (markers[k].title.startsWith(editOrder.orderId + ":")) {
                        let logo = markers[k].icon.url;
                        if (logo.indexOf(green) > 0) {
                            break;
                        }
                        logo = logo.replace(hardwood, green).replace(cedar, green).replace(black, green).replace(red, green).replace(multiple, green);
                        markers[k].setIcon({ url: logo });
                        break;
                    }
                }
            }
            editOrder = null;
        }
    }


    toggleOrder(title) {
        //   this.setState({zoom:map.getZoom()})
        let color = "";
        let types = 0;
        orderId = title.title.substring(0, title.title.indexOf(":"));
        for (let k in markers) {
            if (markers[k].title == title.title) {
                let logo = markers[k].icon.url;
                if (logo.indexOf(green) > 0) {
                    for (let l in this.props.mapOrders) {
                        if (this.props.mapOrders[l].orderId == orderId) {
                            editOrder = this.props.mapOrders[l]
                            if (editOrder.hardwoodBags > 0) {
                                types = types + 1;
                                color = hardwood;
                            }
                            if (editOrder.cedarBags > 0) {
                                types = types + 1;
                                color = cedar;
                            }
                            if (editOrder.blackBags > 0) {
                                types = types + 1;
                                color = black;
                            }
                            if (this.props.mapOrders[l].redBags > 0) {
                                types = types + 1;
                                color = red;
                            }

                            if (types > 1) {
                                color = multiple;
                            }
                        }
                    }
                    logo = logo.replace(green, color);
                    markers[k].setIcon({ url: logo });
                }
                else {
                    logo = logo.replace(hardwood, green).replace(cedar, green).replace(black, green).replace(red, green).replace(multiple, green);
                    markers[k].setIcon({ url: logo });
                }
                break;
            }
        }
        for (let t in this.tempOrders) {
            if (tempOrders[t].orderId == orderId) {
                if (tempOrders[t].deliveryId == 0) {
                    tempOrders[t].deliveryId = this.props.deliveryId;
                }
                else {
                    tempOrders[t].deliveryId = 0;
                }
            }
        }
        this.props.orderUpdated(orderId);
    }

    addMarker(map, order) {

        let title = order.orderId + ":";
        let color = "pink";

        let types = 0;
        let bags = order.hardwoodBags + order.cedarBags + order.blackBags + order.redBags;

        if (order.hardwoodBags > 0) {
            title = title + ' Hardwood ' + order.hardwoodBags;
            types = types + 1;
            color = hardwood;
        }
        if (order.cedarBags > 0) {
            title = title + ' Cedar ' + order.cedarBags;
            types = types + 1;
            color = cedar;
        }
        if (order.blackBags > 0) {
            title = title + ' Black ' + order.blackBags;
            types = types + 1;
            color = black;
        }
        if (order.redBags > 0) {
            title = title + ' Red ' + order.redBags;
            types = types + 1;
            color = red;
        }

        if (types > 1) {
            color = multiple;
        }

        if (order.deliveryId > 0) {
            color = green;
        }
        if (color != 'pink') {

            title = title + ' bags';
            let marker = new window.google.maps.Marker({
                map: map,
                title: title,
                icon: { url: 'https://www.mapcustomizer.com/markers/51120e9b/png/' + color + '/' + bags },
                position: { lat: Number(order.geoLat), lng: Number(order.geoLon) },
            });
            marker.addListener('click', () => {
                this.toggleOrder({ title });
                //markers[0].setIcon({url: 'https://chart.googleapis.com/chart?chst=d_map_spin&chld=0.75|0|aa0000|10|_|100'});
            })
            markers.push(marker);
        }
    }


    render() {
        return (
            <div id='app' style={{ "height": "100%" }}>
                <div id='map' style={{ "height": "100%" }} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        mapOrders: state.orders.orders
    };
}


export default connect(mapStateToProps)(DeliveryMap);


// WEBPACK FOOTER //
// ./src/components/DeliveryMap/DeliveryMap.js